import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppEventsListComponent } from './events-list/hero-events-list.component';
import { AppEventCategoryListComponent } from './event-category-list/event-category-list.component';
import { EventCategoryListTableComponent } from './event-category-list/event-category-list-table/event-category-list-table.component';
import { EventCategoryCreateEditModalComponent } from './event-category-list/event-cateogry-create-edit-modal/event-category-create-edit-modal.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppPaginationModule } from '../../shared/tables/pagination/pagination.module';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { DirectiveModule } from '../../shared/directives/directive.module';
import { AppTablesModule } from '../../shared/tables/tables.module';
import { AppHeroEventCreateEditComponent } from './hero-event-create-edit/hero-event-create-edit.component';
import { MatCardModule } from '@angular/material/card';
import { AppErrorDisplayComponent } from '../../shared/validation/error-display.component';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { AppInputsModule } from '../../shared/inputs/inputs.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { HeroEventCreateEditStudentTableComponent } from './hero-event-create-edit/hero-event-create-edit-student-table/hero-event-create-edit-student-table.component';
import { AppHeroEventCreateEditAddStudentComponent } from './hero-event-create-edit/hero-event-create-edit-add-student/hero-event-create-edit-add-student.component';
import { HeroEventListTableComponent } from './events-list/hero-event-list-table/hero-event-list-table.component';
import { HeroEventListFiltersComponent } from './events-list/hero-event-list-filters/hero-event-list-filters.component';
import { RouterLink } from '@angular/router';
import { ScheduledHeroEventViewEditComponent } from './scheduled-hero-event-view-edit/scheduled-hero-event-view-edit.component';
import { AppAddStudentToScheduledHeroEventModalComponent } from './scheduled-hero-event-view-edit/add-student-to-scheduled-hero-event-modal/add-student-to-scheduled-hero-event-modal.component';
import { ScheduledHeroEventViewStudentTableComponent } from './scheduled-hero-event-view-edit/scheduled-hero-event-view-student-table/scheduled-hero-event-view-student-table.component';
import { AppHistoricalScheduledHeroEventListComponent } from './historical-scheduled-hero-event-list/historical-scheduled-hero-event-list.component';
import {
  BulkEventStudentCsvComponent
} from "./hero-event-create-edit/bulk-event-student-csv/bulk-event-student-csv.component";
import {AppFileUploadModule} from "../../shared/file-upload/file-upload.module";
import { AppMaterialModule } from "src/app/app-material.module";
import { ScheduledHeroEventScanStudentDialogComponent } from './scheduled-hero-event-view-edit/scheduled-hero-event-scan-student-dialog/scheduled-hero-event-scan-student-dialog.component';
import { ScheduledHeroEventOverdueActionsDialogComponent } from './scheduled-hero-event-view-edit/scheduled-hero-event-overdue-actions-dialog/scheduled-hero-event-overdue-actions-dialog.component';
import { AppStudentProfilePhotoModule } from 'src/app/shared/student-profile-photo/student-profile-photo.module';
import { AppAutocompleteModule } from "src/app/shared/dropdowns/autocomplete/autocomplete.module";
import { MatIconModule } from "@angular/material/icon";

@NgModule({
  declarations: [
    AppEventsListComponent,
    AppEventCategoryListComponent,
    EventCategoryListTableComponent,
    EventCategoryCreateEditModalComponent,
    AppHeroEventCreateEditComponent,
    HeroEventCreateEditStudentTableComponent,
    AppHeroEventCreateEditAddStudentComponent,
    HeroEventListTableComponent,
    HeroEventListFiltersComponent,
    ScheduledHeroEventViewEditComponent,
    AppAddStudentToScheduledHeroEventModalComponent,
    ScheduledHeroEventViewStudentTableComponent,
    BulkEventStudentCsvComponent,
    ScheduledHeroEventViewStudentTableComponent,
    AppHistoricalScheduledHeroEventListComponent,
    ScheduledHeroEventViewStudentTableComponent,
    BulkEventStudentCsvComponent,
    ScheduledHeroEventScanStudentDialogComponent,
    ScheduledHeroEventOverdueActionsDialogComponent,
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    MatProgressBarModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    AppPaginationModule,
    MatSortModule,
    MatTableModule,
    DirectiveModule,
    AppTablesModule,
    MatCardModule,
    AppErrorDisplayComponent,
    MatOptionModule,
    MatSelectModule,
    MatCheckboxModule,
    MatDatepickerModule,
    AppInputsModule,
    MatSlideToggleModule,
    FormsModule,
    RouterLink,
    AppFileUploadModule,
    AppMaterialModule,
    AppStudentProfilePhotoModule,
    AppAutocompleteModule,
    MatIconModule
]
})
export class AppEventsModule {}
